import ProfitLossChartContainer from './ProfitLossChartContainer';

export default ProfitLossChartContainer;
